import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42m2KwQmAMBAE038nYiU+BG1C81JQUc7LZbyPQTALA8Mygc+SbKgDuVzhtWxKHFvmocHS/Q8w4Yg9+9R5LLXgBF2dxf0qwQM34H0CAg8YqQAAAABJRU5ErkJggg=="};
